import { PROVIDER_SURGE_INCENTIVE_SET_INCENTIVES } from '../action-types';

export const DEFAULT_STATE = {
  allIds: [],
  byId: {},
  totalEntries: undefined
};

const setIncentives = (state, action) => ({
  ...state,
  ...action.payload
});

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case PROVIDER_SURGE_INCENTIVE_SET_INCENTIVES:
      return setIncentives(state, action);
    default:
      return state;
  }
};
